import { yup } from '@framework/validation';

export const BaseLayoutSchema = yup.object({
  colSpan: yup
    .number()
    .default(1)
    .optional()
    .positive()
    .integer()
    .max(12)
    .label('Numero Colonne'),
  tableColumnWidth: yup
    .number()
    .transform(t => (t === null ? undefined : t))
    .optional()
    .max(100)
    .min(5)
    .label('Larghezza colonna etichetta righe (%)'),
  isTableColumn: yup
    .boolean()
    .default(false)
    .label('Colonna tabella')
    .required(),
});
